import React, { Component } from "react";
import moment from "moment";
import DateGroup from "@components/DateGroup";
import locale from "antd/es/date-picker/locale/zh_CN";
import RadioBtnGroup from "@components/RadioBtnGroup";
import LineDiagram from "@components/Charts/LineDiagram";
import Loading from "@components/BoxLoading";
import "./statistics.css";

import { Card, Select, Button, Table, message, Modal, Switch } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";

import {
  getAllGames,
  searchDataVPC,
  searchDataVPCV2,
  downloadVPC,
} from "@api/statistics";
import { formatDate } from "@utils/tool";
import bus from "@utils/bus";
import constants from "./constants";
import { store } from "../store-manager";
import { getChannelByLvl } from "@api/user";

const downloadjs = require("downloadjs");
const Option = Select.Option;
let allTargetOptions = [];
let jsonAllGames = {};

export default class NewStatisticsSummary extends Component {
  // 金额转换函数：从分转换为元，避免浮点精度问题
  convertCentsToYuan = (cents) => {
    if (cents === undefined || cents === null || cents === "") return 0;
    // 先转换为数字，然后四舍五入到整数，最后除以100
    // 这样可以避免JavaScript浮点计算的精度问题
    const centsNum = Number(cents);
    if (isNaN(centsNum)) return 0;
    const centsInt = Math.round(centsNum);
    return (centsInt / 100).toFixed(2);
  };

  state = {
    isChartLoading: false,
    tagType: true,
    isTableLoading: false,
    selectedVal: {
      time: { start: 0, end: 0 },
      game: [],
      firstLevel: "allFirstLevel",
      secondLevel: "", // "allSecondLevel",
      thirdLevel: ["allThirdLevel"],
    },
    checkAll: false,
    currentTarget: [],
    visible: false,
    allChannel: [],
    allGames: [],
    allSelect: [
      {
        mode: "multiple",
        key: "game",
        placeholder: "请选游戏",
        options: [],
        defaultValue: [],
      },
      {
        key: "firstLevel",
        placeholder: "请选一级渠道",
        defaultValue: "allFirstLevel",
        options: [{ value: "allFirstLevel", label: "全部一级渠道" }],
      },
      {
        mode: "",
        key: "secondLevel",
        defaultValue: "", // "allSecondLevel",
        options: [], //[{ value: "allSecondLevel", label: "全部二级渠道" }],
      },
      {
        mode: "multiple",
        key: "thirdLevel",
        defaultValue: ["allThirdLevel"],
        options: [{ value: "allThirdLevel", label: "全部三级渠道" }],
      },
    ],
    moneyKeys: [
      "pay_money",
      "refund_money",
      "new_user_pay_money",
      "unknown_pay_money",
      "ios_pay_money",
      "android_pay_money",
      "win_pay_money",
    ],
    dateBtns: [
      { key: "0", val: "今天" },
      { key: "-1", val: "昨天" },
      { key: "-7", val: "7天" },
      { key: "-30", val: "30天" },
    ],
    dateDefaultValue: "0",
    targetBtns: [
      { key: "new_user_num", val: "全部新增" },
      { key: "pay_money", val: "全部收入" },
      { key: "active_user_num", val: "活跃人数" },
      { key: "pay_user_num", val: "付费人数" },
      { key: "new_user_pay_money", val: "新增用户收入" },
      { key: "refund_money", val: "退款金额" },
      { key: "android_new_user_num", val: "安卓新增人数" },
      { key: "android_pay_user_num", val: "安卓付费人数" },
      { key: "ios_new_user_num", val: "ios新增人数" },
      { key: "ios_pay_user_num", val: "ios付费人数" },
      { key: "unknown_new_user_num", val: "未知新增人数" },
      { key: "unknown_pay_user_num", val: "未知支付人数" },
      { key: "win_new_user_num", val: "windows新增人数" },
      { key: "win_pay_user_num", val: "windows支付人数" },
    ],
    otherTargetBtns: [
      { key: "one_day_retain_num", val: "单日留存" },
      { key: "one_day_retention", val: "单日留存率" },
      { key: "android_one_day_retain_num", val: "安卓单日留存" },
      { key: "android_one_retention", val: "安卓单日留存率" },
      { key: "ios_one_day_retain_num", val: "ios单日留存" },
      { key: "ios_one_retention", val: "ios单日留存率" },
      { key: "seven_day_retain_num", val: "七天留存" },
      { key: "seven_day_retention", val: "七天留存率" },
      { key: "three_day_retain_num", val: "三天留存" },
      { key: "three_day_retention", val: "三天留存率" },
      { key: "unknown_one_day_retain_num", val: "未知单日留存" },
      { key: "unknown_one_retention", val: "未知单日留存率" },
      { key: "win_one_day_retain_num", val: "windows单日留存" },
      { key: "win_one_day_retention", val: "windows单日留存率" },
      { key: "zero_day_retain_num", val: "零日留存" },
    ],
    targetDefaultValue: "new_user_num",
    otherTargetDefaultValue: "one_day_retain_num",
    echartsOptions: {
      feilds: {},
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985",
          },
        },
        formatter: (params) => {
          let template = ``;
          const feilds = this.state.echartsOptions.feilds;

          template = `<h3 style="color:#fff">${params[0].axisValue}</h3>`;
          params.forEach((val) => {
            const currentVal = val.value[val.seriesName] || 0;

            if (currentVal > 0) {
              template += `
                            <div>${val.marker}${
                feilds
                  ? feilds[val.seriesName] || val.seriesName
                  : val.seriesName
              } : ${currentVal}</div>
                        `;
            }
          });
          return template;
        },
      },
      dataset: {
        dimensions: ["date"],
        source: [],
      },
    },
    typeBtns: [
      { key: "time", val: "按时间汇总" },
      // { key: "game", val: "按产品汇总" },
      { key: "channel", val: "按渠道汇总" },
    ],
    typeDefaultValue: "time",
    tableData: [],
    tableHeadData: [],
    currentTableType: "time",
    promptVisible: false,
    indeterminate: true,
    isOneday: false,
    sumData: {},
    isDeducted: false,
    isAllowUse: false,
    expandedRowKeys: [], // 控制展开的行
    // 添加缓存对象，用于缓存不同查询类型的数据
    tableDataCache: {}, // 格式：{ 'time': { data: [], head: [], rawData: [] }, 'channel': {...}, 'game': {...} }
  };

  handleDownload = () => {
    if (this.state.selectedVal.game.length === 0) {
      message.error("请选写查询条件(游戏)");
      return;
    }

    let params = this.handleParams();
    let tempParams = JSON.parse(JSON.stringify(params));
    let postData = {
      isDeducted: true,
      VPCQueryParams: {
        sqlKey: "",
        customerParamsMap: {},
      },
    };
    postData.VPCQueryParams.customerParamsMap.gameIdList = tempParams.gameIds.includes(
      "*"
    )
      ? []
      : tempParams.gameIds;
    postData.VPCQueryParams.customerParamsMap.channel_1_ids = !!tempParams.topChannel
      ? [tempParams.topChannel]
      : [];
    postData.VPCQueryParams.customerParamsMap.channel_2_ids = tempParams.secondChannel
      ? [tempParams.secondChannel]
      : [];
    postData.VPCQueryParams.customerParamsMap.channel_3_ids =
      tempParams.subChannels;
    //当前查询类型 typeDefaultValue
    if (this.state.isOneday) {
      postData.VPCQueryParams.sqlKey =
        this.state.typeDefaultValue === "time"
          ? "cpsMinigameSummaryHour"
          : this.state.typeDefaultValue === "game"
          ? "cpsMinigameProductSummary"
          : this.state.typeDefaultValue === "channel"
          ? "cpsMinigameChannelSummary"
          : "";
      postData.VPCQueryParams.customerParamsMap.startTime = formatDate(
        tempParams.start * 1000,
        "yyyy-MM-dd"
      );
      postData.VPCQueryParams.customerParamsMap.endTime = formatDate(
        tempParams.start * 1000,
        "yyyy-MM-dd"
      );
    } else {
      postData.VPCQueryParams.sqlKey =
        this.state.typeDefaultValue === "time"
          ? "cpsMinigameTimeSummary"
          : this.state.typeDefaultValue === "game"
          ? "cpsMinigameProductSummary"
          : this.state.typeDefaultValue === "channel"
          ? "cpsMinigameChannelSummary"
          : "";
      postData.VPCQueryParams.customerParamsMap.startTime = this.getCurrentTimeFormat(
        tempParams.start
      );
      postData.VPCQueryParams.customerParamsMap.endTime = this.getCurrentTimeFormat(
        tempParams.end
      );
    }
    downloadVPC(postData).then((res) => {
      downloadjs(res.data);
    });
  };

  /**
   * @desc 当点击一级渠道时 筛出二级渠道
   * @param {*} val
   * @param {*} lvl
   */
  handleChannelLinkage = (val) => {
    let tempAllSelect = this.state.allSelect;
    tempAllSelect[2].options = [
      // { value: "allSecondLevel", label: "全部二级渠道" },
    ];

    const secondChannel = store.remote.secondChannel;
    secondChannel.forEach((ele) => {
      tempAllSelect[2].options.push({
        value: ele.id,
        label: ele.name,
      });
    });
    this.setState({ allSelect: tempAllSelect });
  };

  /**
   * @desc 当点击二级渠道时 筛出三级渠道
   * @param {*} val
   */
  handleSecondChannelToThirdChannel = (val) => {
    let tempAllSelect = this.state.allSelect;
    let tempArr = [];
    const thirdChannel = store.remote.thirdChannel;

    if (val) {
      tempArr = thirdChannel.map((el) => ({ value: el.id, label: el.name }));
    }
    tempAllSelect[3].options = [
      { value: "allThirdLevel", label: "全部三级渠道" },
      ...tempArr,
    ];

    this.setState({ allSelect: tempAllSelect });
  };

  handleChange = async (val = [], key) => {
    const tempSelectedVal = this.state.selectedVal;
    const tempAllSelect = this.state.allSelect;

    if (key === "game") {
      const tempVal = val.includes("*") ? ["*"] : val;

      tempAllSelect[0].defaultValue = tempVal;
      tempSelectedVal.game = tempVal;
    }
    if (key === "firstLevel") {
      await this.getSecondChanelById(val);
      tempAllSelect[1].defaultValue = val;
      tempAllSelect[2].defaultValue = ""; //"allSecondLevel";
      tempAllSelect[3].defaultValue = ["allThirdLevel"];

      Object.assign(tempSelectedVal, {
        firstLevel: val,
        secondLevel: "", //"allSecondLevel",
        thirdLevel: ["allThirdLevel"],
      });

      this.handleChannelLinkage(val);
      //   this.getAllTarget({
      //     firstChannel: val,
      //   });
    }
    if (key === "secondLevel") {
      await this.getThirdChannelById(val);
      tempAllSelect[2].defaultValue = val;
      tempAllSelect[3].defaultValue = ["allThirdLevel"];

      Object.assign(tempSelectedVal, {
        secondLevel: val,
        thirdLevel: ["allThirdLevel"],
      });

      this.handleSecondChannelToThirdChannel(val);
    }
    if (key === "thirdLevel") {
      tempAllSelect[3].defaultValue = val.length === 0 ? [] : val;
      tempSelectedVal.thirdLevel = val;
    }
    this.setState({
      allSelect: tempAllSelect,
      selectedVal: tempSelectedVal,
    });
  };

  onDateChange = (data, btntag) => {
    let tempSelectedVal = this.state.selectedVal;
    tempSelectedVal.time = data;
    let isOneDay = data.end - data.start > 86400 ? false : true;
    this.setState({
      isOneday: isOneDay,
      tagType: isOneDay ? true : this.state.tagType,
      dateDefaultValue: btntag,
      selectedVal: tempSelectedVal,
    });
  };

  handleTargetRadioBtnChange = (data) => {
    if (this.state.tagType)
      this.setState({ targetDefaultValue: data }, () => {
        this.handleSearch();
      });
    else
      this.setState({ otherTargetDefaultValue: data }, () => {
        this.handleSearch();
      });
  };

  handleTypeRadioBtnChange = (data) => {
    this.setState({ typeDefaultValue: data }, () => {
      // 检查缓存，如果有缓存就使用缓存数据，避免重新请求
      const cache = this.state.tableDataCache[data];

      if (cache && cache.data && cache.data.length > 0) {
        this.setState({
          tableData: cache.data,
          tableHeadData: cache.head,
          expandedRowKeys: [], // 切换表格时重置展开状态
        });
      } else {
        let params = this.handleParams();
        this.searchSumData(params);
      }
    });
  };

  getFirstChannel = async () => {
    const ret = await getChannelByLvl(1);
    if (ret && ret.data && ret.data.data) {
      const resp = ret.data.data || [];
      store.sync({
        firstChannel: resp,
      });
      let initOpt = [{ value: "allFirstLevel", label: "全部一级渠道" }];
      // this.setState({ allChannel: [] });
      this.setFormData(this.state.allSelect, "firstLevel", resp, initOpt);
    }
  };

  getSecondChanelById = async (parentId) => {
    const ret = await getChannelByLvl(2, parentId);
    if (ret && ret.data && ret.data.data) {
      const resp = ret.data.data || [];
      store.sync({
        secondChannel: resp,
      });
    }
  };

  getThirdChannelById = async (parentId) => {
    const ret = await getChannelByLvl(3, parentId);
    if (ret && ret.data && ret.data.data) {
      const resp = ret.data.data || [];
      store.sync({
        thirdChannel: resp,
      });
    }
  };

  getAllChannel = async () => {
    await store.hasAllChannel();
    const res = store.remote.channel;

    const data = res || [];
    let initOpt = [{ value: "allFirstLevel", label: "全部一级渠道" }];
    // this.setState({ allChannel: data });
    this.setFormData(this.state.allSelect, "firstLevel", data, initOpt);
  };

  setFormData = (data, key, options, initOpt) => {
    const tempOptions = options || [];
    const tempData = data;
    const tempSelected = this.state.selectedVal;
    const { roleTp, firstLevelChannelIds } = bus.me.data.accountInfo;
    function isShowFirst(roleTp) {
      return roleTp === 5 || roleTp === 6;
    }
    tempData.forEach((item) => {
      if (item.key === key) {
        item.options = isShowFirst(roleTp) ? [] : initOpt.slice();
        item.options = item.options.concat(
          tempOptions.map((item) => {
            return { value: item.id, label: item.name };
          })
        );

        // if (bus.userInfo.isDeducted && item.options.length > 0) {
        //   item.defaultValue = item.options[0].value;
        //   tempSelected.firstLevel = item.defaultValue;
        //   this.handleChannelLinkage(item.defaultValue);
        // }
      }
    });

    this.setState({ allSelect: tempData, selectedVal: tempSelected });
    if (isShowFirst(roleTp)) {
      // 二级渠道管理员 或者 三级渠道管理员
      this.initFirstChannel(firstLevelChannelIds[0]);
    }
  };

  getAllGames = () => {
    getAllGames().then((res) => {
      const games = res.data.data || [];
      let tempData = [{ value: "*", label: "全部游戏" }];
      jsonAllGames = {};

      const specialAccount = [
        "695cc2830e74c9420cc5f54d",
        "695cc1cc0e74c9420cc5f54c",
      ];

      const myAccountId = bus.me.data.accountInfo.id;

      games.forEach((item) => {
        if (!jsonAllGames[item.gameId]) {
          tempData.push({
            value: item.gameId,
            label: item.gameName || item.gameId,
          });
          jsonAllGames[item.gameId] = item.gameName;
        }
      });

      if (specialAccount.includes(myAccountId)) {
        tempData = tempData.filter((item) => {
          return ["fejsfmerge", "pirate-minigame", "*"].includes(item.value);
        });
      }

      let tempAllSelect = this.state.allSelect;

      tempAllSelect[0].options = [];
      tempAllSelect[0].options = tempData;
      this.setState({
        allGames: tempData,
        allSelect: tempAllSelect,
      });
    });
  };

  onChange = (checkedList) => {
    this.setState({
      indeterminate:
        !!checkedList.length && checkedList.length < allTargetOptions.length,
      checkAll: checkedList.length === allTargetOptions.length,
      currentTarget: checkedList,
    });
  };

  onTagSwitchChange = (data) => {
    this.setState({
      tagType: data,
      targetDefaultValue: "new_user_num",
      otherTargetDefaultValue: "one_day_retain_num",
    });
  };

  handleParams = () => {
    let params = {};
    const tempVal = this.state.selectedVal;

    if (tempVal.time.start !== 0) {
      Object.assign(params, tempVal.time);
    }
    if (tempVal.game.length !== 0) {
      Object.assign(params, { gameIds: tempVal.game });
    }
    if (tempVal.firstLevel && tempVal.firstLevel.length !== 0) {
      let tempFirst = tempVal.firstLevel;

      if (tempFirst === "allFirstLevel") {
        tempFirst = "";
      }
      Object.assign(params, { topChannel: tempFirst });
    }
    if (tempVal.secondLevel && tempVal.secondLevel.length !== 0) {
      let tempSecond = tempVal.secondLevel;

      if (tempSecond === "allSecondLevel") {
        tempSecond = "";
      }
      Object.assign(params, { secondChannel: tempSecond });
    }
    if (tempVal.thirdLevel && tempVal.thirdLevel.length !== 0) {
      let arr = tempVal.thirdLevel;

      if (tempVal.thirdLevel.includes("allThirdLevel")) {
        arr = [];
      }
      Object.assign(params, { subChannels: arr });
    }

    return params;
  };

  /** 查询数据 */
  searchData = (params) => {
    let tempParams = JSON.parse(JSON.stringify(params));
    let postData = {
      isDeducted: true,
      VPCQueryParams: {
        sqlKey: "",
        customerParamsMap: {},
      },
    };
    postData.VPCQueryParams.customerParamsMap.gameIdList = tempParams.gameIds.includes(
      "*"
    )
      ? []
      : tempParams.gameIds;
    postData.VPCQueryParams.customerParamsMap.channel_1_ids = !!tempParams.topChannel
      ? [tempParams.topChannel]
      : [];
    postData.VPCQueryParams.customerParamsMap.channel_2_ids = tempParams.secondChannel
      ? [tempParams.secondChannel]
      : [];
    postData.VPCQueryParams.customerParamsMap.channel_3_ids =
      tempParams.subChannels;

    // 判断是小时级指标还是天级指标
    if (this.state.isOneday) {
      postData.VPCQueryParams.sqlKey = "cpsMinigameHour";
      postData.VPCQueryParams.customerParamsMap.startTime = formatDate(
        tempParams.start * 1000,
        "yyyy-MM-dd"
      );
      postData.VPCQueryParams.customerParamsMap.endTime = formatDate(
        tempParams.start * 1000,
        "yyyy-MM-dd"
      );
    } else {
      postData.VPCQueryParams.sqlKey = this.state.tagType
        ? "cpsMinigameDaily"
        : "cpsMinigameRetain";
      postData.VPCQueryParams.customerParamsMap.startTime = this.getCurrentTimeFormat(
        tempParams.start
      );
      postData.VPCQueryParams.customerParamsMap.endTime = this.getCurrentTimeFormat(
        tempParams.end
      );
    }
    return searchDataVPC(postData).then((res) => {
      if (!res || res.data.meta.errCode !== 0) {
        message.error((res && res.data && res.data.meta.errMsg) || "请求失败");
        return;
      }

      let temp = this.state.echartsOptions;
      const game = this.state.selectedVal.game;
      const tempGame = game.includes("*") ? Object.keys(jsonAllGames) : game;

      temp.dataset.source = this.handleChartsData(res.data.data || []);

      temp.feilds = {};
      if (game.includes("*")) {
        temp.dataset.dimensions = ["date"].concat(["all_games"]);
        temp.feilds = {
          all_games: "全部游戏",
        };
      } else {
        temp.dataset.dimensions = ["date"].concat(tempGame);
        tempGame.forEach((item) => {
          temp.feilds[item] = jsonAllGames[item];
        });
      }
      temp.yAxis = {};
      this.setState({ echartsOptions: temp }, () => {
        if (temp.dataset.source.length === 0) return;

        bus.dispatch("echarts_line");
      });
    });
  };

  getCurrentTimeFormat(time) {
    return this.state.isOneday
      ? formatDate(time * 1000, "hh:mm")
      : formatDate(time * 1000, "yyyy-MM-dd");
  }

  handleChartsData(data) {
    if (!data) return [];
    let tempData = [];
    const isSelectAllGames = this.state.selectedVal.game.includes("*");
    data.forEach((ele) => {
      // 将所有moneyKeys字段从分转换为元，避免浮点计算问题
      this.state.moneyKeys.forEach((key) => {
        if (ele[key] !== undefined) {
          ele[key] = this.convertCentsToYuan(ele[key]);
        }
      });

      let itemjson = {};
      if (ele.dh) itemjson.date = ele.dh + ":00:00";
      else itemjson.date = ele.dt;
      let elejson = {};
      let tempValue = ele[
        this.state.tagType
          ? this.state.targetDefaultValue
          : this.state.otherTargetDefaultValue
      ]
        ? ele[
            this.state.tagType
              ? this.state.targetDefaultValue
              : this.state.otherTargetDefaultValue
          ]
        : 0;
      if (parseInt(tempValue) !== Number(tempValue)) {
        tempValue = tempValue.toFixed(4);
      }
      if (isSelectAllGames) {
        ele.game_id = "all_games";
      }
      elejson[ele.game_id] = tempValue;
      Object.assign(itemjson, elejson);
      tempData.push(itemjson);
    });
    tempData.sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    });
    // }
    return tempData;
  }

  searchSumData = (params) => {
    if (!params.gameIds || params.gameIds.length === 0) {
      message.error("请选择查询条件(游戏)");
      return;
    }
    this.setState({
      isTableLoading: true,
      tableData: [],
      tableHeadData: [],
    });
    let tempParams = JSON.parse(JSON.stringify(params));

    let postData = {
      isDeducted: true,
      VPCQueryParams: {
        sqlKey: "",
        customerParamsMap: {},
      },
    };
    postData.VPCQueryParams.customerParamsMap.gameIdList = tempParams.gameIds.includes(
      "*"
    )
      ? []
      : tempParams.gameIds;
    postData.VPCQueryParams.customerParamsMap.channel_1_ids = !!tempParams.topChannel
      ? [tempParams.topChannel]
      : [];
    postData.VPCQueryParams.customerParamsMap.channel_2_ids = tempParams.secondChannel
      ? [tempParams.secondChannel]
      : [];
    postData.VPCQueryParams.customerParamsMap.channel_3_ids =
      tempParams.subChannels;
    //当前查询类型 typeDefaultValue
    if (this.state.isOneday) {
      postData.VPCQueryParams.sqlKey =
        this.state.typeDefaultValue === "time"
          ? "cpsMinigameSummaryHour"
          : this.state.typeDefaultValue === "game"
          ? "cpsMinigameProductSummary"
          : this.state.typeDefaultValue === "channel"
          ? "cpsMinigameChannelSummary"
          : "";
      postData.VPCQueryParams.customerParamsMap.startTime = formatDate(
        tempParams.start * 1000,
        "yyyy-MM-dd"
      );
      postData.VPCQueryParams.customerParamsMap.endTime = formatDate(
        tempParams.start * 1000,
        "yyyy-MM-dd"
      );
    } else {
      postData.VPCQueryParams.sqlKey =
        this.state.typeDefaultValue === "time"
          ? "cpsMinigameTimeSummary"
          : this.state.typeDefaultValue === "game"
          ? "cpsMinigameProductSummary"
          : this.state.typeDefaultValue === "channel"
          ? "cpsMinigameChannelSummary"
          : "";
      postData.VPCQueryParams.customerParamsMap.startTime = this.getCurrentTimeFormat(
        tempParams.start
      );
      postData.VPCQueryParams.customerParamsMap.endTime = this.getCurrentTimeFormat(
        tempParams.end
      );
    }

    return searchDataVPCV2(postData).then((res) => {
      if (!res || res.data.meta.errCode !== 0) {
        message.error((res && res.data && res.data.meta.errMsg) || "请求失败");
        return;
      }
      this.handleSumData(res.data.data || []);
    });
  };

  handleSumData = (val) => {
    let tempJson = {};
    this.state.targetBtns.forEach((item) => {
      tempJson[item.key] = item.val;
    });
    tempJson.game_id = "游戏Id";
    tempJson.channel_1 = "一级渠道";
    tempJson.channel_2 = "二级渠道";
    tempJson.channel_3 = "三级渠道";
    tempJson.channel = "渠道";
    let data = val
      .map((item) => {
        // 将所有moneyKeys字段从分转换为元，避免浮点计算问题
        this.state.moneyKeys.forEach((key) => {
          if (item[key] !== undefined) {
            item[key] = this.convertCentsToYuan(item[key]);
          }
        });

        if (item.dh) {
          item.dh = item.dh.split(" ")[1] + "时";
          delete item.dt;
        } else if (item.dt) {
          // 按时间汇总时保留dt字段
          // 按渠道汇总时也保留dt字段（用于明细数据显示）
          if (
            this.state.typeDefaultValue !== "time" &&
            this.state.typeDefaultValue !== "channel"
          ) {
            delete item.dt;
          }
          delete item.dh;
        } else {
          // 如果既没有dh也没有dt，保持不变
        }
        delete item.latitude;
        delete item.update_time;
        if (this.state.typeDefaultValue !== "game") delete item.game_id;
        if (this.state.typeDefaultValue !== "channel") {
          delete item.channel;
        }
        if (item.new_user_num)
          item.new_user_num = Number(item.new_user_num).toFixed(0);
        return item;
      })
      .sort((a, b) => {
        // 按时间汇总时使用倒序（最新的在前），其他情况使用升序
        if (this.state.typeDefaultValue === "time") {
          return a.dh
            ? b.dh.slice(0, 2) - a.dh.slice(0, 2)
            : new Date(b.dt) - new Date(a.dt);
        } else {
          return a.dh
            ? a.dh.slice(0, 2) - b.dh.slice(0, 2)
            : new Date(a.dt) - new Date(b.dt);
        }
      });

    let tempHeadData = [];
    Object.keys(data[0] || {}).forEach((key) => {
      // 按渠道汇总时，不显示dt和dh列（时间信息已在渠道列中显示）
      if (
        this.state.typeDefaultValue === "channel" &&
        (key === "dt" || key === "dh")
      ) {
        return;
      }

      let title = tempJson[key]
        ? tempJson[key]
        : key === "dt"
        ? "日期"
        : key === "dh"
        ? "时间"
        : "";
      if (title)
        tempHeadData.push({
          title,
          dataIndex: key,
          key: key,
          align: "left",
          width: "150px",
        });
    });

    // 处理按时间汇总：添加汇总行
    if (this.state.typeDefaultValue === "time" && data.length > 0) {
      data = this.generateTimeSummaryData(data, tempHeadData);
    }

    // 处理按渠道汇总：添加总汇总行和树形结构
    if (this.state.typeDefaultValue === "channel" && data.length > 0) {
      data = this.generateChannelSummaryData(data, tempHeadData);
    }

    // 将数据存入缓存
    const currentType = this.state.typeDefaultValue;
    const newCache = {
      ...this.state.tableDataCache,
      [currentType]: {
        data: data,
        head: tempHeadData,
      },
    };

    this.setState({
      tableData: data,
      tableHeadData: tempHeadData,
      isTableLoading: false,
      expandedRowKeys: [], // 每次更新数据时重置展开状态
      tableDataCache: newCache, // 更新缓存
    });
  };

  // 生成按时间汇总的数据（带汇总行）
  generateTimeSummaryData = (data, tempHeadData) => {
    if (data.length === 0) return data;

    // 计算汇总数据
    const summaryRow = {};
    const numericKeys = tempHeadData
      .map((h) => h.dataIndex)
      .filter((key) => key !== "dt" && key !== "dh");

    numericKeys.forEach((key) => {
      const sum = data.reduce((acc, item) => {
        const val = parseFloat(item[key]) || 0;
        return acc + val;
      }, 0);
      // 保留两位小数
      if (this.state.moneyKeys.includes(key)) {
        summaryRow[key] = sum.toFixed(2);
      } else {
        summaryRow[key] = sum.toFixed(0);
      }
    });

    // 设置日期范围（倒序排列：第一条是最新，最后一条是最早）
    const latestDate = data[0].dt || data[0].dh;
    const earliestDate = data[data.length - 1].dt || data[data.length - 1].dh;

    if (data[0].dt) {
      summaryRow.dt = `${earliestDate} ~ ${latestDate}`;
    } else if (data[0].dh) {
      summaryRow.dh = `${earliestDate} ~ ${latestDate}`;
    }

    // 设置唯一key和children
    summaryRow.key = "summary";
    summaryRow.children = data.map((item, index) => ({
      ...item,
      key: `detail_${index}`,
    }));

    // 汇总行样式标记
    summaryRow.isSummary = true;

    return [summaryRow];
  };

  // 处理展开/收起行
  handleExpandRow = (record) => {
    const { expandedRowKeys } = this.state;
    const key = record.key;

    // 如果该行没有children，不处理
    if (!record.children || record.children.length === 0) {
      return;
    }

    const index = expandedRowKeys.indexOf(key);
    const newExpandedRowKeys = [...expandedRowKeys];

    if (index > -1) {
      // 已展开，收起
      newExpandedRowKeys.splice(index, 1);
    } else {
      // 未展开，展开
      newExpandedRowKeys.push(key);
    }

    this.setState({ expandedRowKeys: newExpandedRowKeys });
  };

  // 自定义展开图标
  customExpandIcon = (props) => {
    const { expanded, onExpand, record } = props;

    // 如果该行没有children，不显示图标
    if (!record.children || record.children.length === 0) {
      return <span style={{ display: "inline-block", width: 17 }} />;
    }

    const IconComponent = expanded ? DownOutlined : RightOutlined;
    return (
      <IconComponent
        onClick={(e) => {
          e.stopPropagation();
          onExpand(record, e);
        }}
        style={{
          cursor: "pointer",
          fontSize: 14,
          fontWeight: "bold",
          color: "#000",
          marginRight: 8,
          transition: "all 0.3s",
        }}
      />
    );
  };

  // 生成按渠道汇总的树形数据（带总汇总行）
  generateChannelSummaryData = (data, tempHeadData) => {
    if (data.length === 0) return data;

    // 按渠道分组
    const channelGroups = {};
    data.forEach((item) => {
      const channel = item.channel;
      if (!channelGroups[channel]) {
        channelGroups[channel] = [];
      }
      channelGroups[channel].push(item);
    });

    // 计算每个渠道的汇总
    const channelSummaries = Object.keys(channelGroups).map((channel, idx) => {
      const items = channelGroups[channel];
      const summaryRow = { channel };

      const numericKeys = tempHeadData
        .map((h) => h.dataIndex)
        .filter((key) => key !== "channel" && key !== "dt" && key !== "dh");

      numericKeys.forEach((key) => {
        const sum = items.reduce((acc, item) => {
          const val = parseFloat(item[key]) || 0;
          return acc + val;
        }, 0);
        if (this.state.moneyKeys.includes(key)) {
          summaryRow[key] = sum.toFixed(2);
        } else {
          summaryRow[key] = sum.toFixed(0);
        }
      });

      summaryRow.key = `channel_${idx}`;

      // 先对items按时间倒序排列（最新的在前）
      const sortedItems = items.sort((a, b) => {
        if (a.dh && b.dh) {
          return b.dh.localeCompare(a.dh);
        } else if (a.dt && b.dt) {
          return new Date(b.dt) - new Date(a.dt);
        }
        return 0;
      });

      // 将明细行的channel字段替换为时间字段（dt或dh）
      summaryRow.children = sortedItems.map((item, index) => {
        const childItem = { ...item };
        // 将渠道列显示为时间
        if (childItem.dt) {
          childItem.channel = childItem.dt;
        } else if (childItem.dh) {
          childItem.channel = childItem.dh;
        }
        childItem.key = `channel_${idx}_${index}`;
        return childItem;
      });
      summaryRow.isChannelSummary = true;

      return summaryRow;
    });

    // 计算总汇总
    const totalSummary = { channel: "总计" };
    const numericKeys = tempHeadData
      .map((h) => h.dataIndex)
      .filter((key) => key !== "channel" && key !== "dt" && key !== "dh");

    numericKeys.forEach((key) => {
      const sum = data.reduce((acc, item) => {
        const val = parseFloat(item[key]) || 0;
        return acc + val;
      }, 0);
      if (this.state.moneyKeys.includes(key)) {
        totalSummary[key] = sum.toFixed(2);
      } else {
        totalSummary[key] = sum.toFixed(0);
      }
    });

    totalSummary.key = "total_summary";
    totalSummary.isTotalSummary = true;

    // 总计行单独列在第一行，后面跟各个渠道的汇总行
    return [totalSummary, ...channelSummaries];
  };

  isCanSearch() {
    const {
      game,
      thirdLevel,
      secondLevel,
      time: { start, end },
    } = this.state.selectedVal;
    if (!start || !end) {
      message.error("请选择查询条件(时间)");
      return false;
    }
    const gameIsEmpty = game.length === 0;
    const secondIsEmpty = !secondLevel || secondLevel.length === 0;
    const thirdIsEmpty = thirdLevel.length === 0;
    const errText = `请选择查询条件(${gameIsEmpty ? "游戏" : "三级渠道"})`;

    if (secondIsEmpty) {
      message.error("请选择查询条件(二级渠道)");
      return false;
    }
    if (gameIsEmpty || thirdIsEmpty) {
      message.error(errText);
      return false;
    }
    return true;
  }

  handleSearch = async () => {
    const isCanFlag = this.isCanSearch();
    if (!isCanFlag) {
      return;
    }
    // 查询条件改变时，清空缓存
    this.setState({
      tableDataCache: {},
    });

    // 自定义loading，放弃使用全局loading
    this.setState({
      isChartLoading: true,
      isTableLoading: true,
    });
    let params = this.handleParams();
    await this.searchData(params);
    this.setState({
      isChartLoading: false,
    });
    await this.searchSumData(params);
    this.setState({
      isTableLoading: false,
    });
  };

  initFirstChannel(val) {
    this.handleChange(val, "firstLevel");
  }

  componentWillMount() {
    const tempIsDeducted = false; // bus.userInfo.isDeducted;
    let allowUse = false;
    if (bus.userInfo.secondLevelChannelIds[0] === "636c956d12365f0f861b53c7")
      allowUse = true;
    if (tempIsDeducted) {
      this.setState({
        isDeducted: tempIsDeducted,
        isAllowUse: allowUse,
        dateBtns: [
          { key: "-7", val: "7天" },
          { key: "-30", val: "30天" },
        ],
        dateDefaultValue: "-7",
        typeBtns: [{ key: "time", val: "按时间汇总" }],
      });
    }
  }

  componentDidMount() {
    const { roleTp, firstLevelChannelIds } = bus.me.data.accountInfo;
    const params = {};
    if (roleTp === 5 || roleTp === 6) {
      // 二级渠道管理员 或者 三级渠道管理员
      params.firstChannel = firstLevelChannelIds[0];
    }

    this.getFirstChannel();
    this.getAllGames();
  }

  render() {
    const columns = [
      {
        title: "指标",
        dataIndex: "target",
        align: "left",
        width: "40%",
      },
      {
        title: "说明",
        dataIndex: "name",
        align: "left",
        width: "60%",
      },
    ];
    const data = constants;
    const {
      targetBtns,
      dateBtns,
      dateDefaultValue,
      targetDefaultValue,
      tableHeadData,
      tableData,
      promptVisible,
      tagType,
      otherTargetDefaultValue,
      otherTargetBtns,
      isOneday,
    } = this.state;

    return (
      <div className="statistics">
        <h4 style={{ marginTop: 8, width: 140 }}>统计汇总</h4>
        <Card
          style={{
            marginTop: 10,
            borderRadius: 8,
          }}
        >
          <ul className="statistics_select">
            {this.state.allSelect.map((item) => {
              return (
                <li key={item.key} className="s_select_item">
                  <Select
                    optionFilterProp="label"
                    allowClear={false}
                    className="custom-select"
                    maxTagCount={1}
                    mode={item.mode || ""}
                    placeholder={item.placeholder}
                    value={item.defaultValue}
                    onChange={(value) => {
                      this.handleChange(value, item.key);
                    }}
                    style={{ width: "100%" }}
                    showSearch
                  >
                    {item.options.map((ele) => {
                      return (
                        <Option
                          key={ele.value}
                          value={ele.value}
                          label={ele.label}
                          className="custom-select-option"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{ele.label}</span>
                          {item.key === "game" && (
                            <span style={{ color: "gray", fontSize: ".7rem" }}>
                              {ele.value}
                            </span>
                          )}
                        </Option>
                      );
                    })}
                  </Select>
                </li>
              );
            })}
          </ul>
          <div className="time_row">
            <div className="time_row_l">
              <DateGroup
                max={moment("2025-12-31").endOf("day")}
                locale={{
                  ...locale,
                  lang: {
                    ...locale.lang,
                    shortMonths: [
                      "一月",
                      "二月",
                      "三月",
                      "四月",
                      "五月",
                      "六月",
                      "七月",
                      "八月",
                      "九月",
                      "十月",
                      "十一月",
                      "十二月",
                    ],
                  },
                }}
                className="custom-date-group"
                onDateChange={this.onDateChange}
                btns={dateBtns}
                defaultValue={dateDefaultValue}
                isDeducted={false}
              />
            </div>
            <div className="time_row_r">
              <Button
                type="primary"
                onClick={this.handleSearch}
                style={{ borderRadius: 12 }}
              >
                查询
              </Button>
            </div>
          </div>
        </Card>
        <div style={{ position: "relative" }}>
          <Loading isLoading={this.state.isChartLoading} />
          <Card
            title="统计"
            extra={
              bus.me.data.accountInfo.roleTp === 5 ||
              bus.me.data.accountInfo.roleTp === 6 ? null : (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Switch
                    style={{ marginLeft: 8 }}
                    checkedChildren="常规指标"
                    unCheckedChildren="留存指标"
                    disabled={isOneday}
                    defaultChecked={tagType}
                    checked={tagType}
                    onChange={this.onTagSwitchChange}
                  />
                  <Button
                    size="small"
                    type="primary"
                    onClick={() => {
                      this.setState({ promptVisible: true });
                    }}
                  >
                    ?
                  </Button>
                </div>
              )
            }
            style={{
              width: "100%",
              marginTop: 10,
              borderRadius: 8,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                marginTop: 0,
              }}
            >
              <RadioBtnGroup
                onChange={this.handleTargetRadioBtnChange}
                defaultValue={
                  tagType ? targetDefaultValue : otherTargetDefaultValue
                }
                btns={tagType ? targetBtns : otherTargetBtns}
              />
            </div>
            <LineDiagram options={this.state.echartsOptions} />
          </Card>
        </div>
        {/* 产品反馈以下注释内容有问题，需要隐藏 */}
        <div
          className="table-container"
          style={{
            overflow: "hidden",
            position: "relative",
          }}
        >
          <RadioBtnGroup
            onChange={this.handleTypeRadioBtnChange}
            defaultValue={this.state.typeDefaultValue}
            btns={this.state.typeBtns}
          />
          <Button
            type="primary"
            style={{
              marginRight: 8,
              position: "absolute",
              bottom: 0,
              right: 0,
            }}
            onClick={this.handleDownload}
          >
            下载表格
          </Button>
        </div>
        <div className="table-box" style={{ position: "relative" }}>
          <Loading isLoading={this.state.isTableLoading} />
          <Table
            locale={{ emptyText: "暂无数据" }}
            scroll={{ x: tableHeadData.length * 200 }}
            rowKey={(record) =>
              record.key ||
              record["channel"] ||
              record["game_id"] ||
              record["dt"] ||
              record["dh"]
            }
            style={{
              marginTop: 18,
              borderRadius: 8,
              overflow: "hidden",
              boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.1)",
            }}
            columns={tableHeadData}
            dataSource={tableData}
            pagination={false}
            rowClassName={(record) => {
              if (record.isTotalSummary) return "total-summary-row";
              if (record.isChannelSummary) return "channel-summary-row";
              if (record.isSummary) return "summary-row";
              return "";
            }}
            expandedRowKeys={this.state.expandedRowKeys}
            onExpand={(expanded, record) => {
              const newExpandedRowKeys = expanded
                ? [...this.state.expandedRowKeys, record.key]
                : this.state.expandedRowKeys.filter(
                    (key) => key !== record.key
                  );
              this.setState({ expandedRowKeys: newExpandedRowKeys });
            }}
            indentSize={20}
            onRow={(record) => ({
              onClick: () => {
                this.handleExpandRow(record);
              },
              style: {
                cursor:
                  record.children && record.children.length > 0
                    ? "pointer"
                    : "default",
              },
            })}
            expandIcon={this.customExpandIcon}
          />
        </div>
        <Modal
          width="800px"
          destroyOnClose={true}
          title="提示信息"
          visible={promptVisible}
          footer={null}
          onOk={() => {
            this.setState({ promptVisible: false });
          }}
          onCancel={() => {
            this.setState({ promptVisible: false });
          }}
          okText="确认"
          cancelText="取消"
        >
          <Table
            pagination={false}
            // style={{width: '100%', height: '100%'}}
            scroll={{ x: "100%", y: 400 }}
            columns={columns}
            dataSource={data}
          />
        </Modal>
      </div>
    );
  }
}

